import { render, staticRenderFns } from "./TourGroupInstanceTransfer.vue?vue&type=template&id=14a829f3&scoped=true&"
import script from "./TourGroupInstanceTransfer.vue?vue&type=script&lang=js&"
export * from "./TourGroupInstanceTransfer.vue?vue&type=script&lang=js&"
import style0 from "./TourGroupInstanceTransfer.vue?vue&type=style&index=0&id=14a829f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a829f3",
  null
  
)

export default component.exports